import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { useGetOrderDetailsQuery } from "../../../rtk-query/slices/dashboard/dashboard-slice";
import errorIcon from "../../../assets/no-book-icon.png";
import { ShimmerThumbnail, ShimmerText } from "react-shimmer-effects";
import { usePostMarkAsRedeemMutation } from "../../../rtk-query/slices/finance/financeSlice";
import { toast } from "react-toastify";
const OrderDetailsModal = ({
  orderNumber,
  show,
  handleClose,
  setOrderNumber,
}) => {
  const { data, isLoading, isError, error, isFetching } =
    useGetOrderDetailsQuery(orderNumber, { skip: !show });

  const [postMarkAsRedeem, { isLoading: isPostMarkAsRedeemLoading }] =
    usePostMarkAsRedeemMutation();

  const handleRedeemNow = async () => {
    try {
      const bodyData = [data?.data?.order_id]; // Extract only the IDs of the selected items
      const response = await postMarkAsRedeem({ order_id: bodyData });
      if (response?.data) {
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      if (response?.error) {
        toast.error(response?.error?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (e) {
      toast.error(e?.message, {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      handleClose();
      setOrderNumber("");
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        setOrderNumber("");
      }}
      centered
      className="order-details-modal"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fw-medium">Order Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading || isFetching ? (
          <div className="order-card p-3 rounded">
            <ShimmerText line={1} gap={10} />
            <ShimmerText line={1} gap={10} className="mt-2" />
            <ShimmerText line={1} gap={10} className="mt-2" />
            <ShimmerThumbnail height={40} className="mt-3" />
          </div>
        ) : isError ? (
          <div className="text-center d-flex flex-column align-items-center ">
            <img width={150} height={150} src={errorIcon} alt="error" />
            <p>{error?.data?.error || "Something went wrong!"}.</p>
          </div>
        ) : (
          <div className="order-card p-3 rounded">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className=" fw-bold">
                  BR-{data?.data?.voucher_number}
                </span>
                <div className="text-muted">
                  <Icon icon="mdi:calendar" className="calendar-icon" />{" "}
                  {data?.data?.trip_date}
                </div>
              </div>
              <div className="text-end fw-bold">
                <span className="fw-lighter">Your amount</span>{" "}
                <span className="">AED {data?.data?.total_amount}</span>
              </div>
            </div>
            <hr />
            <h5 className="fw-medium">{data?.data?.product_title}</h5>
            <p>
              <span className="fw-semibold">Lead Traveler :</span>{" "}
              {data?.data?.first_name} {data?.data?.last_name} &nbsp;&nbsp;
              <span className="fw-semibold">No. of Traveler :</span>{" "}
              {data?.data?.lineItems?.map((item, index) => {
                return (
                  <span key={index}>
                    {item?.quantity} {item?.pax_type_name}
                  </span>
                );
              })}
            </p>
          </div>
        )}
      </Modal.Body>
      {!isError && (
        <Modal.Footer className="border-0">
          <Button
            disabled={isPostMarkAsRedeemLoading}
            className="redeem-btn w-50 m-auto"
            onClick={handleRedeemNow}
          >
            Redeem Now{" "}
            {isPostMarkAsRedeemLoading && (
              <Spinner size="sm" className="ms-1" />
            )}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default OrderDetailsModal;
